import { useAuthorizedQuery } from ".";
import { params } from "../params";
import { useAuthorizedMutation } from ".";
import { useContext } from "react";
import { FeatureAccessContext } from "../context/featureAccess";

export const useGetTopics = (enabled: boolean = true) => {
  return useAuthorizedQuery({
    queryKey: "topics",
    url: `${params.API_URL}/platform/dashboard/topics`,
    method: "GET",
    enabled,
  });
};

export interface CreateTopicPayload {
  topic: string;
  description?: string;
}

export interface UpdateTopicPayload {
  id: number;
  topic?: string;
  description?: string;
}

export const useCreateTopic = () => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/topic`,
    method: "POST",
  });
};

export const useUpdateTopic = (topicId: number) => {
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/topic/${topicId}`,
    method: "PUT",
  });
};

export interface MergeTopicPayload {
  fromTopicId: number;
  toTopicId: number;
}

export const useMergeTopic = () => {
  const { selectedWorkspace } = useContext(FeatureAccessContext);
  return useAuthorizedMutation({
    url: `${params.API_URL}/platform/topic/merge`,
    method: "POST",
  });
};
